import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Education = () => {
  return (
    <section className="education" id="education">
      <Container>
        <Row>
          <Col>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible
                      ? "animate__animated animate__slideInUp"
                      : ""
                  }
                >
                  <h2>Education</h2>

                  <p className="education-intro">
                    My academic foundation in information technology,
                    computer science, and software engineering.
                  </p>
                </div>
              )}
            </TrackVisibility>

            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={`education-card ${
                    isVisible
                      ? "animate__animated animate__fadeInUp"
                      : ""
                  }`}
                >
                  <div className="education-year">
                    Dec. 2021 – Jun. 2025
                  </div>

                  <div className="education-content">
                    <h3>
                      Bachelor of Technology — Information Technology
                    </h3>

                    <h4>
                      National Institute of Technology, Kurukshetra
                    </h4>

                    <p>
                      Kurukshetra, Haryana, India
                    </p>

                    <div className="education-tags">
                      <span>Information Technology</span>
                      <span>Data Structures & Algorithms</span>
                      <span>Computer Networks</span>
                      <span>DBMS</span>
                      <span>Operating Systems</span>
                      <span>Software Engineering</span>
                    </div>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
